// Carousel.js
import React, { useState } from "react";

const images = [
  "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
];

export default function Carousel() {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % images.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div>
      <div className="w-full h-[100px] sm:h-[320px] rounded-lg overflow-hidden relative group">
        <img
          src={"/image/marketplacebanner.png"}
          alt="Cover"
          className="w-full h-[100px] rounded-xl sm:h-[280px] object-cover group-hover:opacity-80 transition"
        />
      </div>
      {/* <div className="relative w-full h-64 flex items-center justify-center bg-gray-100 rounded-lg overflow-hidden">
        <button
          onClick={prevSlide}
          className="absolute left-4 z-10 bg-white rounded-full p-2 shadow hover:bg-gray-200"
        >
          &lt;
        </button>
        <img
          src={images[current]}
          alt="carousel"
          className="h-full w-full object-contain"
        />
        <button
          onClick={nextSlide}
          className="absolute right-4 z-10 bg-white rounded-full p-2 shadow hover:bg-gray-200"
        >
          &gt;
        </button>
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex space-x-2">
          {images.map((_, idx) => (
            <span
              key={idx}
              className={`h-2 w-2 rounded-full ${
                current === idx ? "bg-green-600" : "bg-gray-400"
              }`}
            ></span>
          ))}
        </div>
      </div> */}
    </div>
  );
}
